import * as yup from 'yup';

export const validationSchema = yup.object({
    name: yup.string().required(),
    company: yup.string().required(),
    category: yup.string().required(),
    price: yup.number().required().moreThan(100),
    quantityRemains: yup.number().required().min(0),
    description: yup.string().required(),
    file: yup.mixed().when('pictureUrl', (pictureUrl, schema) => {
        return pictureUrl ? schema : schema.required('Please attach an image!');
    })
});